import HubbleBaseApi from '../HubbleBaseApi';

class PassApi extends HubbleBaseApi {
  /**
   * Creates a coworking pass booking.
   *
   * @param {string} bookingDate The date that the booking is being made for.
   * @param {string} buildingId Unique identifier for the building the booking is being made for.
   * @param {string} company Where the user works.
   * @param {string} email Contact email address for the booking user.
   * @param {string} name The name of the user booking the space.
   * @param {string} phoneNumber Contact phone number for the booking user.
   *
   */
  async createBooking(payload) {
    return this.post('pass/bookings', payload);
  }

  /**
   * Get coworking pass bookings
   *
   * @param {number} offset The offset from which this endpoint is returning the next 10 results
   */
  async getBookings(payload) {
    return this.get('pass/bookings', payload);
  }

  /**
   * Sets the status of an entire booking to cancelled
   *
   * @param {number} bookingId the ID of the booking from which the attendee is removed
   */
  async deleteBooking(bookingId) {
    return this.delete(`pass/bookings/${bookingId}/`);
  }
  /**
   * Removes an attendee from a booking
   *
   * @param {number} bookingId the ID of the booking from which the attendee is removed
   * @param {number} id the ID of the attendee that is removed from the booking
   */
  async deleteBookingAttendee(bookingId, id) {
    return this.delete(`pass/bookings/${bookingId}/attendees/${id}/`);
  }

  /**
   * Get the status of a user's organisation's free trial
   */
  async getFreeTrialStatus() {
    return this.get('pass/free-trials/status');
  }

  /**
   * Get the account details of a user's organisation
   */
  async getFinanceAccount() {
    return this.get('pass/finance-account');
  }

  /**
   * Get users stripe customer portal link
   */
  async getCustomerPortal(payload, opts) {
    return this.get('pass/customer-portal', payload, opts);
  }

  /**
   * Get the stripe checkout session
   */
  async getCheckout(payload, opts) {
    return this.get('pass/checkout', payload, opts);
  }

  /**
   * Get buildings available for pass booking
   */
  async getSearch(payload) {
    return this.get('pass/search', payload);
  }

  /**
   * Get an organisation's subscription details
   */
  async getSubscription() {
    return this.get('pass/subscription');
  }

  /**
   * Get an organisation's upcoming invoice details
   */
  async getUpcomingInvoice() {
    return this.get('pass/upcoming-invoice');
  }
}

export default PassApi;
